<template>
    <div class="flex justify-center my-4" data-testid="unread-separator">
        <span
            class="px-3 py-1 rounded-full text-sm font-semibold text-blue-600 bg-blue-100"
            :class="{ 'cursor-pointer hover:bg-blue-200': clickable && !loading }"
            @click="clickable && !loading && $emit('click')"
        >
            <activix-spinner class="inline-block h-4 w-4 mr-1" v-if="loading" />
            <template v-else>
                {{ t('smsCommunication.messagesList.unreadSeparator')
                }}{{ showScrollHint ? ' ↑' : '' }}
            </template>
        </span>
    </div>
</template>

<script setup lang="ts">
    import { useI18n } from '@/hooks/useI18n.ts';
    import ActivixSpinner from '@/components/activix-ui/ActivixSpinner/ActivixSpinner.vue';

    interface Props {
        showScrollHint?: boolean;
        clickable?: boolean;
        loading?: boolean;
    }

    withDefaults(defineProps<Props>(), {
        showScrollHint: false,
        clickable: false,
        loading: false,
    });

    defineEmits<(e: 'click') => void>();

    const { t } = useI18n();
</script>
